import React from 'react';
import styled from 'styled-components';
// { withTheme }

import { useTheme } from '@material-ui/styles';
import { orange, green, red } from '@material-ui/core/colors';

import {
  CardContent,
  Card as MuiCard,
  TableCell as MuiTableCell,
  TableRow as MuiTableRow,
  Table,
  TableBody,
  TableHead,
  Typography
} from '@material-ui/core';

import { spacing } from '@material-ui/system';

import { Doughnut } from 'react-chartjs-2';

const Card = styled(MuiCard)(spacing);

const Spacer = styled.div(spacing);

const ChartWrapper = styled.div`
  height: 168px;
  position: relative;
`;

const DoughnutInner = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -22px;
  text-align: center;
  z-index: 0;
`;

const TableRow = styled(MuiTableRow)`
  height: 42px;
`;

const TableCell = styled(MuiTableCell)`
  padding-top: 0;
  padding-bottom: 0;
`;

const GreenText = styled.span`
  color: ${() => green[400]};
  font-weight: ${props => props.theme.typography.fontWeightMedium};
`;

const RedText = styled.span`
  color: ${() => red[400]};
  font-weight: ${props => props.theme.typography.fontWeightMedium};
`;

const PieChart = () => {
  const theme = useTheme();
  const data = {
    labels: ['Social', 'Search Engines', 'Direct', 'Other'],
    datasets: [
      {
        data: [260, 125, 54, 146],
        backgroundColor: [
          theme.palette.secondary.main,
          orange[500],
          red[500],
          theme.palette.grey[300]
        ],
        borderColor: 'transparent'
      }
    ]
  };

  const options = {
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    cutoutPercentage: 84
  };

  return (
    <Card mb={3}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Symmetry
        </Typography>

        <Spacer mb={6} />

        <ChartWrapper>
          <DoughnutInner variant="h4">
            <Typography variant="h4">left/right</Typography>
            <Typography variant="caption">...</Typography>
          </DoughnutInner>
          <Doughnut data={data} options={options} />
        </ChartWrapper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell align="right">Days</TableCell>
              <TableCell align="right">%</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">
                Upper body
              </TableCell>
              <TableCell align="right">7</TableCell>
              <TableCell align="right">
                <GreenText theme={theme}>49</GreenText>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Lower body
              </TableCell>
              <TableCell align="right">14</TableCell>
              <TableCell align="right">
                <RedText theme={theme}>56</RedText>
              </TableCell>
            </TableRow>
            
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
export default PieChart;
// export default withTheme(PieChart);
